import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from './../../../_services/admin.service';
import { Component, OnInit } from '@angular/core';
import { Task } from 'src/app/_models/task';

@Component({
  selector: 'app-question-template-questions',
  templateUrl: './question-template-questions.component.html',
  styleUrls: ['./question-template-questions.component.css']
})
export class QuestionTemplateQuestionsComponent implements OnInit {
  taskTemplate= new Task()
  questions =[]
  dtOptions: DataTables.Settings = {};
  loading = false
  constructor(
    private adminService:AdminService,
    private route:ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.loading=true
    this.dtOptions = {
      pagingType: 'full_numbers'
     };
  this.route.params.subscribe(
    params=>{
      let id=params['server_task_template_id']
      if(id!=0){
        this.adminService.getQuestionTemplateQuestionsById(id).subscribe(
          val=>{
            this.taskTemplate=val
            this.loading=false
          }
        )
      }

    }
  )

  }


}
